<template>
	<div class="scroll-reveal">
    <div class="container">
      <div>
        <!-- <h4>{{ $route.params.name.replace(/-/g, ' ') }}</h4> -->

        <div v-for="(element, index) in elements" :key="index">
          <div class="row" v-if="element.type == 'text'">
            <vue-markdown class="markdown scroll-reveal" style="width:100%"> {{ element.content }} </vue-markdown>
          </div>
          <div class="row" v-if="element.type == 'image'">
            <div class="row">
              <div class="col m8 offset-m2">
                <img :src="'/php/elements/' + element.content" class="materialboxed scroll-reveal responsive-img">
              </div>
            </div>
          </div>
          <div class="row" v-if="element.type == 'video'">
            <div class="col m8 offset-m2">
              <div class="video-container scroll-reveal">
                <iframe width="853" height="480" :src="'https://www.youtube.com/embed/' + element.content" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import axios from "axios";
import VueMarkdown from "vue-markdown";
export default {
  name: "pagePost",
  components: {
    VueMarkdown
  },
  data() {
    return {
      elements: []
    };
  },
  methods: {
    getData() {
      axios
        .get("/php/pages/read.php?pageQuery=" + this.$route.params.name)
        .then(response => {
          //this.pre = false;
          this.elements = response.data.elements;
          console.log(response.data);
          this.scrollReveal();

          //console.log(this.elements);
        })
        .catch(error => {
          M.toast({
            html: "Ha ocurrido un error"
          });
          console.log(error);
        });
    },
    scrollReveal() {
      ScrollReveal().reveal(".scroll-reveal");
      var elems = document.querySelectorAll(".materialboxed");
      var instances = M.Materialbox.init(elems, {});
    }
  },
  mounted() {
    this.getData();
    // this.scrollReveal();
  },
  updated() {
    // this.scrollReveal();
  },
  watch: {
    $route(to, from) {
      this.elements = [];
      this.getData();
      this.scrollReveal();
    }
  },
  computed: {
    srcImg() {
      return "/php/elements/";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/pagepost.vue